import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import * as Sentry from "@sentry/angular";
// Ionic Native packages removed - migrated to Capacitor plugins
// StatusBar: Use @capacitor/status-bar
// SplashScreen: Use @capacitor/splash-screen
// InAppBrowser: Use @capacitor/browser
// Deeplinks: Use @capacitor/app (App URL handling)
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { environment } from '../environments/environment';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireFunctionsModule, REGION } from '@angular/fire/compat/functions';

import { ImageCropperModule } from 'ngx-image-cropper';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { FormsModule } from '@angular/forms';
import { ClipboardModule } from 'ngx-clipboard';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ModalModule } from './home/imp-modal/imp-modal.module';
import { UserOrdersComponent } from './home/tdct-user/user-orders/user-orders.component';
import { SitemapComponent } from './sitemap/sitemap.component';
import { ImageModalComponent } from './image-modal/image-modal.component';
import { ImpEventTicketOptionComponent } from './home/imp-event/imp-event-option-ticket-creator-form/imp-event-option-ticket-creator-form.component';
import { ImpEventTableOptionComponent } from './home/imp-event/imp-event-option-table-creator-form/imp-event-option-table-creator-form.component';
import { ImpEventOptionBottleCreatorFormComponent } from './home/imp-event/imp-event-option-bottle-creator-form/imp-event-option-bottle-creator-form.component';
import { TableBottleSelectionModalComponent } from './home/imp-event/imp-event-detail/table-bottle-selection-modal/table-bottle-selection-modal.component';
import { SharedModule } from './shared/shared.module';
// BarcodeScanner migrated to @capacitor-mlkit/barcode-scanning
import { GuestListModalModule } from './home/imp-event/guest-list-modal/guest-list-modal.module';
import { ImpEventDetailComponent } from './home/imp-event/imp-event-detail/imp-event-detail.component';

@NgModule({ declarations: [
        AppComponent,
        UserOrdersComponent,
        SitemapComponent,
        ImageModalComponent,
        ImpEventTicketOptionComponent,
        ImpEventTableOptionComponent,
        ImpEventOptionBottleCreatorFormComponent,
        TableBottleSelectionModalComponent,
        ImpEventDetailComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        SharedModule,
        IonicModule.forRoot(),
        AppRoutingModule,
        AngularFireModule.initializeApp(environment.firebase),
        AngularFirestoreModule,
        AngularFireStorageModule,
        AngularFireAuthModule,
        AngularFireFunctionsModule,
        ImageCropperModule,
        NgxQRCodeModule,
        FormsModule,
        ClipboardModule,
        ModalModule,
        GuestListModalModule], providers: [
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        { provide: REGION, useValue: 'us-central1' },
        { provide: ErrorHandler, useValue: Sentry.createErrorHandler({ showDialog: false }) },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
